// extracted by mini-css-extract-plugin
export default {"TextArea":"CustomTextArea_TextArea__LyuNt","TextArea_wrap":"CustomTextArea_TextArea_wrap__99XX7","invalid":"CustomTextArea_invalid__3AL9E"};